module.exports = __webpack_public_path__ + "static/media/facileristrutturare-mobile.26082c26.svg";